__turbopack_context__.v({
  "card": "styles-module__t9S5eG__card",
  "cardDescription": "styles-module__t9S5eG__cardDescription",
  "cardPadding": "styles-module__t9S5eG__cardPadding",
  "cardTitle": "styles-module__t9S5eG__cardTitle",
  "cards": "styles-module__t9S5eG__cards",
  "materials": "styles-module__t9S5eG__materials",
  "projectInfo": "styles-module__t9S5eG__projectInfo",
  "solution": "styles-module__t9S5eG__solution",
  "task": "styles-module__t9S5eG__task",
});
